import csvToJson from "@/utils/csvToJson";

// CSV import utility
export const getJsonData = async (
  file: File,
  columnMapping?: string[]
): Promise<Record<string, string>[]> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      try {
        const csvContent = e.target?.result as string;
        const jsonData = JSON.parse(csvToJson(csvContent, columnMapping));
        resolve(jsonData);
      } catch (error) {
        reject(new Error("Failed to parse CSV file"));
      }
    };

    reader.onerror = () => reject(new Error("Failed to read file"));
    reader.readAsText(file);
  });

export const getNecessaryData = (
  data: Record<string, string>[]
): Record<string, string>[] => {
  // exclude data id has no product code or variant code
  const necessaryData = data.filter((item) => {
    return item["Product Code"] !== "-" || item["Variant Code"] !== "-";
  });

  return necessaryData;
};
